// Complete teaching sections relocated verbatim from the biography.
export const worshipAcademyReadings = [
  {
    "id": "wisdom",
    "title": "Musical Wisdom",
    "source": "https://lorisholland.com/wisdom.html",
    "blocks": [
      {
        "type": "heading",
        "text": "Musical Wisdom"
      },
      {
        "type": "heading",
        "text": "The Truth About Music"
      },
      {
        "type": "p",
        "text": "\"Music is art and science, its the enlightenment of the purest , spiritually logical form of bliss that soothes the savage beast in all of us. Its a true mystery and a great gift from God( The Master Musician)to mankind. It justifies the reality of our existence as we all have the need for, and the ability to create it. We are all born with the gift, and the desire to share our unique styles of musical creativity as we feed our spirits, bodies and souls regularly with its joy.\" This is my belief."
      },
      {
        "type": "heading",
        "text": "My Life"
      },
      {
        "type": "p",
        "text": "I was born in Guyana when it was British Guiana, grew up in the Amazon basin, lived in England, Canada and most of my life in the USA."
      },
      {
        "type": "p",
        "text": "I grew up in a musical family, always surrounded and influenced by a wide variety of styles, and my musical life journeyed through many cultures and genres. Classical, sacred, reggae, African folk, calypso, jazz, gospel, country, R&B, rock, etc. the list is lengthy, and It's difficult to accurately classify the path with such a merge of cultures that frame pop culture today, but I relish learning the sound of new things, mixing them with the old, and blending cultural nuances musically."
      },
      {
        "type": "heading",
        "text": "Experience"
      },
      {
        "type": "p",
        "text": "I'm a composer/arranger/singer/keyboardist, writer, privileged to have worked with a long list of amazingly talented creative people."
      },
      {
        "type": "p",
        "text": "I've also worked in the advertising industry and Daytime TV, as a composer/musician/singer, for many years, including some film work, receiving Grammy and Emmy award recognition as a Composer/Producer/Musician, on several occasions."
      },
      {
        "type": "p",
        "text": "Much of that work has been joyful, and I’m proud of parts of it. But over the decades, my frustration with having to create within the commercial music industry’s demands for success and survival began to outweigh my sense of musical growth. That path can be one of integrity. I’m not downplaying the accomplishments of my friends, peers or mentors. For me, though, there had to be more. In my spare time, I wrote songs simply for my own listening pleasure. That was how I soothed the inner beast. It became a therapeutic shadow project, and over time it grew into TimeShadow, finally taking over me."
      },
      {
        "type": "heading",
        "text": "My band"
      },
      {
        "type": "p",
        "text": "The TomorrowBand grew into a collection of like-minded musicians and singers who contributed creatively and emotionally to that journey."
      },
      {
        "type": "p",
        "text": "As the artist TimeShadow, with the help of The TomorrowBand, I wrote, collaborated with others, performed and produced a collection of works that embodied a 30 year journey."
      },
      {
        "type": "p",
        "text": "The first installment of that creative collection was the project \"TOMORROW\"."
      },
      {
        "type": "p",
        "text": "Tomorrow is a 24 song collection, which underscores a series of 24 documentary short films threaded by 24 poems using animation and motion graphics to aid in the story."
      },
      {
        "type": "p",
        "text": "A. (The Poems)"
      },
      {
        "type": "p",
        "text": "Chasing Tomorrow - A collection of 24 poems"
      },
      {
        "type": "p",
        "text": "B. (The Music)"
      },
      {
        "type": "p",
        "text": "Tomorrow AM & Tomorrow PM - A 24 song double CD"
      },
      {
        "type": "p",
        "text": "C. (The tv mini-series)"
      },
      {
        "type": "p",
        "text": "TOMORROW The 24hr. Saga - A six part documentary series of 24 vignettes highlighting society’s trending habits and practices today, and their impact on tomorrow."
      },
      {
        "type": "heading",
        "text": "Life in Balance"
      },
      {
        "type": "p",
        "text": "At that stage, I found balance working primarily from my home studio and teaching piano and vocal students locally and abroad. Music education is a family tradition, handed down from my grandparents to my mother, uncles, sister, cousins and me. I sat on the board of directors of The Ruby Holland School of Music, founded by and named after my mother. My sister Elizabeth ran it as president. TimeShadow’s mission was world peace and cultural blending through a love of truth and music. Its website was www.timeshadow.com."
      }
    ]
  },
  {
    "id": "instruction",
    "title": "Music instruction",
    "source": "https://lorisholland.com/instruction.html",
    "blocks": [
      {
        "type": "heading",
        "text": "Music instruction by Loris Holland"
      },
      {
        "type": "heading",
        "text": "Overview"
      },
      {
        "type": "p",
        "text": "I approach music education by looking at both the artistic effects of music and the mathematics that help us understand its science."
      },
      {
        "type": "p",
        "text": "I teach my students to explore their creative abilities by understanding the source of musical form, recognizing similarities and emulating what they hear through practice and performance."
      },
      {
        "type": "heading",
        "text": "Method"
      },
      {
        "type": "p",
        "text": "My method is unorthodox: I introduce college-level music analysis and harmony from day one. I want my students to grasp the logic, the universal concepts and the science of the art from the beginning."
      },
      {
        "type": "p",
        "text": "I focus on ear training, musical form and song structure, bringing classical and jazz theory together and applying them across genres, from gospel to pop. I teach students to listen for and recognize musical forms in popular music, then analyze, emulate and create them."
      },
      {
        "type": "heading",
        "text": "Piano And Voice"
      },
      {
        "type": "p",
        "text": "The instrument that allows fluid understanding of the entire musical spectrum, is the piano. The piano is the beast that lives in the jungle of black and white keys. That beast can become a beauty. My piano method is called \"Playing By Ear\". My vocal method is called \"Liking Your Own Voice\"."
      },
      {
        "type": "p",
        "text": "Singing brings a spiritual fulfillment as mysterious as the emotions it creates. Most of us want to sing but hate our voices. I developed my vocal teaching method from decades of producing vocalists, training choirs and studying music. I help students build confidence with projection, pitch, tone, lung capacity, breathing in rhythm, diction, and a range of performance and recording techniques."
      },
      {
        "type": "p",
        "text": "Confidence and the joy of accomplishment in music take commitment, dedication and practice. I discuss those disciplines in the orientation interview. When I accept a student, I design a course and method of study around their individual goals and the time they can commit to practice."
      },
      {
        "type": "p",
        "text": "I give students the fundamentals to pursue excellence in any genre."
      },
      {
        "type": "p",
        "text": "I teach adults, youth, and children, from beginning level to professionals."
      },
      {
        "type": "p",
        "text": "I believe that we are all musicians, since we were created in the image of GOD The Ultimate Master Creator Musician."
      }
    ]
  }
];
